import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-recalculate',
  templateUrl: './dialog-recalculate.component.html',
  styleUrls: ['./dialog-recalculate.component.scss'],
})
export class DialogRecalculateComponent implements OnInit {
  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() value: any;

  ngOnInit(): void {
    this.onChange.emit(true);
  }
}
